import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../../theme';
/**
 * `<Eyebrow>` — tracked-caps section header atom from the LOCI · CLT design system.
 *
 * Space Grotesk 600, 12px, 0.18em letter-spacing, uppercase. Default color resolves
 * to the theme accent (Electric Amber): darkened amber on light backgrounds, electric
 * amber glow on dark backgrounds — both meet WCAG AA contrast on their respective surfaces.
 */
export const Eyebrow = forwardRef(({ color = 'accent', style, children, ...rest }, ref) => {
    const theme = useTheme();
    const eyebrowStyles = {
        fontFamily: theme.typography.fontFamilyDisplay ?? theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeight.semibold,
        fontSize: theme.typography.fontSize.caption,
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        color: color === 'accent' ? theme.colors.accent : 'inherit',
        ...style,
    };
    return (_jsx("span", { ref: ref, style: eyebrowStyles, ...rest, children: children }));
});
Eyebrow.displayName = 'Eyebrow';
